import * as React from 'react'
import { IconsModel } from './iconsModel'

function SvgCommon(
	{
		color,
		width = 50,
		height = 50
	}: IconsModel
) {
	return (
		<svg width={width} height={height}>
			<defs>
				<filter id="common_svg__a">
					<feColorMatrix
						in="SourceGraphic"
						values="0 0 0 0 0.070588 0 0 0 0 0.164706 0 0 0 0 0.254902 0 0 0 1.000000 0"
					/>
				</filter>
			</defs>
			<g>
				<path
					fill={color}
					d="M9.69 32.675h16.66c3.97 0 6.068-2.098 6.068-6.068h-1.645c0 3.059-1.364 4.423-4.423 4.423H8.044v8.742H.125v1.644h48.953v-1.644H9.69v-7.097m8.74-8.742h16.662c3.97 0 6.067-2.098 6.067-6.068h-1.645c0 3.06-1.364 4.423-4.422 4.423H16.786v6.068h1.645v-4.423m8.742-8.742h16.66c3.97 0 6.068-2.098 6.068-6.067h-1.645c0 3.058-1.364 4.422-4.422 4.422H25.528v6.068h1.645V15.19"
				/>
			</g>
		</svg>
	)
}

export default SvgCommon
